// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__07QVY","mini":"Menu_mini__xOZVs"};